import CashbackIcon from '../CashbackIcon';
import type { DailyReward } from '../../types';
import type { Language } from '../../i18n';
import { useTranslation } from '../../hooks/useTranslation';

interface DailyCheckInRewardsProps {
  dailyRewards: DailyReward[];
  currentDay: number;
  isCheckedInToday: boolean;
  countdown: string;
  language: Language;
  formatPoints: (points: number) => string;
  onCheckIn: () => void;
  checkingIn: boolean;
  loadingText: string;
}

const DailyCheckInRewards = ({
  dailyRewards,
  currentDay,
  isCheckedInToday,
  countdown,
  formatPoints,
  onCheckIn,
  checkingIn,
  loadingText,
}: DailyCheckInRewardsProps) => {
  const { t } = useTranslation();
  return (
    <div className="mb-6">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-lg font-semibold text-white">
          {t('checkIn.title')}
        </h2>
        {!isCheckedInToday && (
          <div className="text-sm text-tg-hint">
            {countdown}
          </div>
        )}
      </div>
      <div className="grid grid-cols-3 gap-2">
        {dailyRewards.map((reward) => {
          const isClaimed = reward.claimed;
          const isCurrent = !isClaimed && reward.day === currentDay + 1;
          return (
            <div
              key={reward.day}
              className={`bg-tg-secondary rounded-lg p-3 text-center border border-gray-800 transition-all duration-300 ${
                isCurrent ? 'border-2 border-primary shadow-lg shadow-primary/30' : ''
              } ${isClaimed ? 'opacity-50' : 'hover:border-primary/50 hover:bg-[#2a2a2a] hover:scale-105 hover:shadow-lg hover:shadow-primary/20'} cursor-pointer`}
            >
              <div className={`flex justify-center mb-1 ${isClaimed ? 'text-gray-500' : 'text-primary'}`}>
                <CashbackIcon size={24} />
              </div>
              <div className={`text-sm font-semibold mb-1 ${isClaimed ? 'text-gray-500' : 'text-white'}`}>
                {formatPoints(reward.points)} XP
              </div>
              <div className="text-xs text-tg-hint">
                {`Day ${reward.day}`}
                {isClaimed && ` (${t('checkIn.checkedIn')})`}
              </div>
            </div>
          );
        })}
      </div>
      {!isCheckedInToday && (
        <button
          onClick={onCheckIn}
          disabled={checkingIn}
          className="w-full mt-4 py-3 bg-primary text-black rounded-lg font-semibold transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-primary/30 active:scale-100 disabled:opacity-60 disabled:hover:scale-100"
        >
          {checkingIn ? loadingText : t('checkIn.checkIn')}
        </button>
      )}
    </div>
  );
};

export default DailyCheckInRewards;

